"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const _ = require("lodash");
const moment = require("moment");
const utils_1 = require("@common/utils");
class AppService {
    constructor(token) {
        this.token = token;
        this.httpService = axios_1.default;
        this.setInterceptors();
    }
    setInterceptors() {
        this.httpService.interceptors.response.use(null, (exception) => {
            const errors = _.get(exception, "response.data.errors");
            if (_.isArray(errors) && errors.length > 0) {
                const messages = errors.map((error) => error.detail);
                if (_.isArray(_.first(messages))) {
                    return Promise.reject({ isHandled: true, messages: [].concat.apply([], messages) });
                }
                return Promise.reject({ isHandled: true, messages });
            }
            return Promise.reject(exception);
        });
    }
    getHeaders() {
        const headers = {};
        headers.Authorization = `Bearer ${this.token}`;
        headers["Content-Type"] = "application/json";
        return headers;
    }
    //#otherFunctions
    async setAuditFields(item) {
        if (!_.isNil(item.created_at)) {
            const createdAt = new Date(item.created_at);
            item.created_at = moment(createdAt).format('MM/DD/YYYY');
        }
        if (!_.isNil(item.modified_at)) {
            const modifiedAt = new Date(item.modified_at);
            item.modified_at = moment(modifiedAt).format('MM/DD/YYYY');
        }
        if (!_.isNil(item.created_by)) {
            item.created_by = item.created_by.includes("@") ? utils_1.Format.setUserName(item.created_by) : item.created_by;
        }
        if (!_.isNil(item.modified_by)) {
            item.modified_by = item.modified_by.includes("@") ? utils_1.Format.setUserName(item.modified_by) : item.modified_by;
        }
        return item;
    }
}
exports.AppService = AppService;
//# sourceMappingURL=app.service.js.map